import React, { createContext, useContext } from 'react'; //eslint-disable-line
import { StoreType, StoreTypesReversed } from '../interfaces/store_types';

interface StoreContent {
  store: StoreType;
}

export const StoreContext = createContext<StoreContent>({
  store: StoreTypesReversed.Premium,
});

export const useStoreContext = () => useContext(StoreContext);
